<template>
  <div
    class="position-absolute right-0 top-0 mt-2 mr-2"
  >
    <DropdownMenu>
      <DropdownMenuTrigger
        class="btn btn-light btn-icon btn-xs"
      >
        <i class="fa-solid fa-ellipsis"></i>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          as="a"
          target="_blank"
          :href="teamAsset.real_url"
          class="tw-text-foreground"
        >
          View
        </DropdownMenuItem>
        <DropdownMenuItem @select="startRenaming">
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem @select="startSharing">
          Share Settings
        </DropdownMenuItem>
        <DropdownMenuItem @select="deleteTeamAsset(teamAsset)">
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script>
import { useTeamAssetItem } from './use-team-asset-item'
import { useTeamAssets } from './use-team-assets'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem
} from '@/shadcn/components/ui/dropdown-menu'

export default {
  name: 'TeamAssetItemMenu',
  components: {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem
  },
  setup () {
    const { teamAsset, toggleIsRenaming } = useTeamAssetItem()
    const { deleteTeamAsset, teamAssetSharingFormRef } = useTeamAssets()

    const startSharing = () => {
      if (teamAssetSharingFormRef.value) {
        teamAssetSharingFormRef.value.startSharing(teamAsset.value)
      }
    }

    const startRenaming = () => {
      toggleIsRenaming(true)
    }

    return {
      teamAsset,
      deleteTeamAsset,
      startSharing,
      startRenaming
    }
  }
}
</script>
